import {
  ChangeDetectionStrategy,
  Component,
  booleanAttribute,
  inject,
  input,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeadlineComponent } from '../headline/headline.component';
import { DialogModule } from '@angular/cdk/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DividerComponent } from '../divider/divider.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ESCAPE, hasModifierKey } from '@angular/cdk/keycodes';
import { EMPTY, filter, merge, tap } from 'rxjs';

type Width = 'sm' | 'lg' | 'xl' | 'auto';

export interface DialogData {
  title: string;
  content: string;
  width: Width;
}

@Component({
  selector: 'ui-dialog',
  standalone: true,
  imports: [
    CommonModule,
    HeadlineComponent,
    DialogModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    DividerComponent,
  ],
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogComponent {
  dialogRef = inject(MatDialogRef);

  width = input<Width>('sm');
  noDialogTitle = input(false, { transform: booleanAttribute });
  noDialogActions = input(false, { transform: booleanAttribute });
  titleDivider = input(false, { transform: booleanAttribute });
  actionDivider = input(false, { transform: booleanAttribute });
  customCloseEvent = input(false, { transform: booleanAttribute });

  closed = output<void>();

  closeIconClicked() {
    if (!this.customCloseEvent()) this.dialogRef.close();

    this.closed.emit();
  }

  constructor() {
    merge(
      this.dialogRef.backdropClick(),
      (this.dialogRef.keydownEvents?.() ?? EMPTY).pipe(
        filter(event => event.keyCode === ESCAPE && !hasModifierKey(event))
      )
    )
      .pipe(
        takeUntilDestroyed(),
        tap(() => {
          this.closed.emit();
        })
      )
      .subscribe();
  }
}
